<template>
  <v-container fill-height fluid grid-list-sm>
    <v-layout>
      <v-flex md12 lg12>
        <Reservas />
      </v-flex>
      

    </v-layout>
  </v-container>
</template>
<script>
import Reservas from "./ReservasList";
/* import uhs from './UHs' */
export default {
  components: {
    Reservas,
    /* uhs */
  },
  data: () => ({
 
    
  })
}

</script>